/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import * as References from './PublicSearchService';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'search',
  args: ['pageLength', 'search', 'sortingType', 'featuredHomepageOnly', 'featuredCertificationsOnly', 'hasAwardsOnly', 'shouldFilterDeprecated', 'levels', 'categories', 'hubSpotSoftware', 'contentTypes', 'durations', 'language', 'offset'],
  fetcher(request) {
    return chirpClient.call(References.searchRpc, {
      request
    });
  }
});